import { render, staticRenderFns } from "./ViewGrid.vue?vue&type=template&id=71451f08&scoped=true&"
import script from "./ViewGrid.vue?vue&type=script&lang=js&"
export * from "./ViewGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71451f08",
  null
  
)

export default component.exports